import React from 'react';

import { Action, Actions } from '@gogame/components';
import { Screen, useParams, ScreenLink } from '@gogame/screens';

import { marketingPlanningWizardLevelsLink } from 'scenes/MarketingPlanning/navigation';

const MarketingPlanningActions = () => {
  const { year, month, ...params } = useParams();
  const levelPath = params['*'];

  const [
    networkId,
    applicationId,
    channelId,
    platformId,
    affiliateId,
    countryId,
    managerId,
  ] = levelPath.split('/').filter((i) => i);

  return (
    <Screen.Toolbar.Actions>
      <Actions>
        <Action
          button={true}
          component={ScreenLink}
          label={'Edit Plan'}
          variant={'outlined'}
          componentProps={{
            link: marketingPlanningWizardLevelsLink,
            pathParams: {
              year,
              month,
              networkId,
              applicationId,
              channelId,
              platformId,
              affiliateId,
              countryId,
              managerId,
            },
          }}
        />
      </Actions>
    </Screen.Toolbar.Actions>
  );
};

export default MarketingPlanningActions;
